import { useContext, useMemo } from "react";
import "./UserWageHistory.scss";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { useSelector } from "react-redux";
import dayjsTZ from "../../../utils/dayjs";
import { getMonthStatistic } from "./calculations";
import { useAuth } from "../../../authentication/authHelpers";
import PunonjesitContext from "../../punonjesit/store/PunonjesitContext";

function UserWageHistory({ employee }) {
  const reduxWages = useSelector((state) => state.wages?.wages);
  const { specsData } = useContext(PunonjesitContext);
  const wages = employee ? specsData?.wages ?? reduxWages : reduxWages;
  const auth = useAuth();

  const wagesHistoryData = useMemo(() => {
    if (!wages) return [];

    let months = [];
    if (employee && specsData?.mode === "custom" && specsData?.fromDate && specsData?.toDate) {
      let cursor = dayjsTZ(specsData.fromDate).startOf("month");
      const end = dayjsTZ(specsData.toDate).startOf("month");
      while (cursor.isBefore(end) || cursor.isSame(end, "month")) {
        months.push(cursor);
        cursor = cursor.add(1, "month");
      }
      if (months.length === 0) months = [dayjsTZ(specsData.fromDate).startOf("month")];
    } else if (employee && specsData?.year && specsData?.month) {
      months = [dayjsTZ(`${specsData.year}-${specsData.month}`, "YYYY-M").startOf("month")];
      // show surrounding context: up to 6 months ending at selected month
      const selected = months[0];
      months = [...Array(6)].map((_, idx) =>
        dayjsTZ(selected).subtract(5 - idx, "months")
      );
    } else {
      const currentMom = dayjsTZ().startOf("month");
      months = [...Array(6)].map((_, idx) =>
        dayjsTZ(currentMom).subtract(5 - idx, "months")
      );
    }

    const employeeId = employee || auth?.employeeId;
    if (!employeeId) return [];

    return months.map((month) => {
      const res = getMonthStatistic(wages, month, employeeId);
      return {
        name: dayjsTZ(month).format("MMMM YYYY"),
        "Shuma Neto": res?.neto?.toFixed(2),
      };
    });
  }, [wages, employee, auth, specsData?.mode, specsData?.year, specsData?.month, specsData?.fromDate, specsData?.toDate]);

  return (
    <div
      className="wages-data-chart"
      style={{
        width: !employee ? 795 : 370,
        height: !employee ? 225 : "100%",
        padding: 10,
        boxShadow: "0px 1px 4px #00000029",
        borderRadius: "0 0 5px 5px",
      }}
    >
      <ResponsiveContainer>
        <AreaChart
          data={wagesHistoryData}
          margin={{
            top: 10,
            right: 30,
            left: 0,
            bottom: 0,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Area
            type="monotone"
            dataKey="Shuma Neto"
            stackId="1"
            stroke="#82ca9d"
            fill="#82ca9d"
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}

export default UserWageHistory;
